var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9008 0.972046H8.07557C7.68435 0.972046 7.36719 1.28477 7.36719 1.67052V16.5643C7.36719 16.9501 7.68435 17.2628 8.07557 17.2628H11.9008C12.2921 17.2628 12.6092 16.9501 12.6092 16.5643V1.67052C12.6092 1.28472 12.2921 0.972046 11.9008 0.972046Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2916 9.65649H15.4663C15.0751 9.65649 14.7579 9.96922 14.7579 10.355V16.5691C14.7579 16.9548 15.0751 17.2676 15.4663 17.2676H19.2916C19.6828 17.2676 20 16.9548 20 16.5691V10.355C20 9.96917 19.6828 9.65649 19.2916 9.65649Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53365 6.53662H0.708383C0.317158 6.53662 0 6.84934 0 7.2351V16.5597C0 16.9455 0.317158 17.2582 0.708383 17.2582H4.53365C4.92487 17.2582 5.24203 16.9455 5.24203 16.5597V7.2351C5.24203 6.84934 4.92487 6.53662 4.53365 6.53662Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.8f059233.svg";
export { ForwardRef as ReactComponent };